// ForgotPassword.jsx (only the important bits shown)
import React, { useState } from "react";
import { Container, Paper, Stack, TextField, Button, Typography, Alert } from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";

const actionCodeSettings = {
  url: `${window.location.origin}/login?reset=1`, // where user lands after clicking email
  handleCodeInApp: false,                         // true only if you implement in-app handling
};

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState("");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setOk(""); setErr(""); setBusy(true);
    try {
      await sendPasswordResetEmail(auth, email.trim(), actionCodeSettings);
      setOk(`Password reset email sent to ${email.trim()}.`);
    } catch (e) {
      setErr(e?.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Reset your password</Typography>
        {ok && <Alert severity="success" sx={{ mb: 2 }}>{ok}</Alert>}
        {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
        <form onSubmit={onSubmit}>
          <Stack spacing={2}>
            <TextField label="Work Email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} />
            <Button type="submit" variant="contained" disabled={busy}>
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
